module.exports = __webpack_public_path__ + "assets/img/246201.662265ba.png";